// 고객 화면 맨 아래 작은 로고 + 「로 관리되는 현장입니다」 한 줄 — show 는 페이지가 brandFooterOn 으로 읽어 넘기고(기본 켬), 끄면 아무것도 그리지 않는다.

import { cn } from "@/lib/utils";
import { BRAND_FOOTER_HREF, BRAND_FOOTER_SUFFIX, BRAND_FOOTER_TEXT } from "@buildpy/core/modules/org/brand";
import { BrandLogo } from "@buildpy/ui/brand-logo";

interface Props {
  show: boolean;
  className?: string;
}

const CustomerFooter = ({ show, className }: Props) =>
  show ? (
    <p className={cn("print-hide mt-8 text-center text-xs text-muted-foreground", className)} data-testid="customer-footer">
      <a
        aria-label={BRAND_FOOTER_TEXT}
        className="inline-flex items-center gap-x-0.5 underline-offset-2 hover:underline"
        href={BRAND_FOOTER_HREF}
        rel="noopener"
        target="_blank">
        <BrandLogo size="xs" />
        <span>{BRAND_FOOTER_SUFFIX}</span>
      </a>
    </p>
  ) : null;

export default CustomerFooter;
